import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { SecurityService } from '~/services/security.service';

@Injectable({ providedIn: 'root' })
export class AuthenticationGuard implements CanActivate {

  constructor(
    private router: Router,
    private _securityService: SecurityService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.getLicenseObservable().pipe(
      switchMap(() => {
        if (localStorage.getItem('accessToken')) {
          return this._securityService.hasAccessObservable(route.data).pipe(
            switchMap(hasAccess => {
              if (hasAccess) {
                if (this._securityService.hasLicense(route.data, state.url)) {
                  return this.isRouteAllowedObservable(state.url).pipe(
                    map(isAllowed => {
                      if (isAllowed) {
                        return true;
                      }
                      this.router.navigate(['/unlicensed']);
                      return false;
                    })
                  );
                } else {
                  this.router.navigate(['/unlicensed']);
                  return of(false);
                }
              }
              return of(false);
            })
          );
        } else {
          this.router.navigate(['/login'], {
            queryParams: { returnUrl: state.url },
          });
          return of(false);
        }
      })
    );
  }

  getLicenseObservable(): Observable<any> {
    return this._securityService.getLicenseObservable();
  }

  isRouteAllowedObservable(url: string): Observable<boolean> {
    return this._securityService.isRouteAllowed(url);
  }
}

// Export alias for backward compatibility with 300+ routing modules
export { AuthenticationGuard as Authentication };
